import { Card, CardBody, Col } from "reactstrap";
import { Grouping } from "../../../../Constant";
import { GroupingFirst } from "./GroupingFirst";
import { GroupingSecond } from "./GroupingSecond";
import { GroupinThird } from "./GroupingThird";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { GROUPING_DATA } from "../../../../Data/UiKit/Avatars";

const GroupingCart = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={Grouping} span={GROUPING_DATA} />
        <CardBody>
          <div className="avatar-showcase">
            <div className="avatars">
              <GroupingFirst />
              <GroupingSecond />
              <GroupinThird />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GroupingCart;
